import { API_BASE_URL } from "../config/api";
import { resolveApiMessage } from "../utils/resolveApiMessage";

let _token = null;
export function setToken(token) { _token = token; }

export async function saveAssignment(accessKey, items, splitLotes = [], mode = "process") {
  const url = new URL(`/nfe/${accessKey}/save-assignment`, API_BASE_URL);

  const response = await fetch(url.toString(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(_token ? { Authorization: `Bearer ${_token}` } : {}),
    },
    body: JSON.stringify({ items, splitLotes, mode }),
  });

  const text = await response.text();
  let data;
  try {
    data = JSON.parse(text);
  } catch {
    throw new Error("Resposta inválida do servidor");
  }

  if (response.status === 423) {
    throw new Error(`Item bloqueado por ${data.locked_by || "outro usuário"}`);
  }

  if (!response.ok) {
    throw new Error(resolveApiMessage(data, "Erro ao salvar atribuição"));
  }

  return data;
}
